import { reactive, defineAsyncComponent } from 'vue';
import { mountHost } from '@martyrs/src/modules/core/views/plugins/host.js';

const OtpDialog = defineAsyncComponent(() =>
  import('@martyrs/src/modules/auth/views/components/blocks/OtpDialog.vue')
);

const state = reactive({
  visible: false,
  mode: 'single', // 'single' или 'dual'
  challenge: null,
  challenges: null,
  resolve: null,
  reject: null
});

export function showOtp(challenge) {
  if (state.visible) {
    return Promise.reject(new Error('OTP dialog already open'));
  }

  return new Promise((resolve, reject) => {
    state.resolve = resolve;
    state.reject = reject;
    state.challenge = challenge;
    state.mode = 'single';
    state.visible = true;
  });
}

export function showDualOtp(challenges) {
  if (state.visible) {
    return Promise.reject(new Error('OTP dialog already open'));
  }

  return new Promise((resolve, reject) => {
    state.resolve = resolve;
    state.reject = reject;
    state.challenges = challenges;
    state.mode = 'dual';
    state.visible = true;
  });
}

export function closeOtp(code) {
  state.visible = false;
  state.resolve?.(code);
  state.resolve = state.reject = null;
}

export function closeDualOtp(codes) {
  state.visible = false;
  state.resolve?.(codes);
  state.resolve = state.reject = null;
}

export function cancelOtp() {
  state.visible = false;
  state.reject?.(new Error('OTP cancelled'));
  state.resolve = state.reject = null;
}

export async function withOtp(makeRequest, data) {
  const result = await makeRequest(data);

  if (result.data?.status === 'requires_otp') {
    if (result.data.mode === 'dual') {
      const codes = await showDualOtp(result.data.challenges);
      return makeRequest({
        ...data,
        challenges: [
          { challengeId: result.data.challenges[0].challengeId, code: codes[0] },
          { challengeId: result.data.challenges[1].challengeId, code: codes[1] }
        ]
      });
    } else {
      const code = await showOtp(result.data.challenge);
      return makeRequest({
        ...data,
        challengeId: result.data.challenge.challengeId,
        otp: code
      });
    }
  }

  return result;
}

export default {
  install(app) {
    app.config.globalProperties.$showOtp = showOtp;
    app.config.globalProperties.$showDualOtp = showDualOtp;

    // Код подтверждения спрашивают ПОВЕРХ другого попапа (вход, оплата),
    // поэтому его слой выше остальных хостов.
    mountHost(app, {
      id: 'otp-dialog-host',
      className: 'z-index-7',
      component: OtpDialog,
      props: { otpState: state, closeOtp, closeDualOtp, cancelOtp },
    });
  }
};
